var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "91px",
    viewBox: "0 0 92 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.15 0C55.6116 0 56.8162 1.09378 56.9808 2.50291L57 2.83333L57 65.1667C57 66.6197 55.8998 67.8173 54.4824 67.9809L54.15 68L2.85 68C1.38842 68 0.183805 66.9062 0.019174 65.4971L0 65.1667L0 59.5C0 57.9352 1.27599 56.6667 2.85 56.6667C4.31158 56.6667 5.5162 57.7604 5.68083 59.1696L5.7 59.5L5.7 62.3333L51.3 62.3333L51.3 5.66667L25.7048 5.66614L5.7 6.04633L5.7 36.8333C5.7 38.2864 4.59979 39.4839 3.18237 39.6476L2.85 39.6667C1.38842 39.6667 0.183805 38.5729 0.019174 37.1638L0 36.8333L0 3.26923C0 1.83591 1.07163 0.647486 2.46763 0.461261L2.7952 0.436421L25.65 0L54.15 0Z",
    transform: "matrix(1 0 0 -1 17 79)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(48 31)",
    id: "Path-4-Copy-2",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.049 0.939808C13.0886 -0.21598 14.8795 -0.320086 16.049 0.707282C17.1286 1.65562 17.3014 3.23656 16.5039 4.38323L16.2843 4.66023L8.72876 13.0602C7.74148 14.1578 6.08414 14.3024 4.92352 13.4496L4.64439 13.2156L0.866617 9.61556C-0.259798 8.54216 -0.29241 6.76959 0.793776 5.65643C1.79641 4.6289 3.40187 4.5224 4.52888 5.35635L4.80004 5.58445L6.45149 7.15961L12.049 0.939808Z",
    transform: "translate(28 25)",
    id: "Path-8",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(48 50)",
    id: "Path-4-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 0C12.9456 0 14.2188 1.2592 14.2188 2.8125C14.2188 4.25485 13.1209 5.44361 11.7066 5.60608L11.375 5.625L2.84375 5.625C1.27319 5.625 0 4.3658 0 2.8125C0 1.37015 1.0978 0.181386 2.51211 0.0189217L2.84375 0L11.375 0Z",
    transform: "matrix(0.70710677 0.70710677 -0.70710677 0.70710677 32.508526 46.421677)",
    id: "Path-4-Copy-3",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.375 0C12.9456 0 14.2188 1.2592 14.2188 2.8125C14.2188 4.25485 13.1209 5.44361 11.7066 5.60608L11.375 5.625L2.84375 5.625C1.27319 5.625 0 4.3658 0 2.8125C0 1.37015 1.0978 0.181386 2.51211 0.0189217L2.84375 0L11.375 0Z",
    transform: "matrix(-0.7071067 0.7071068 0.7071068 0.7071067 38.585224 46.421677)",
    id: "Path-4-Copy-3",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(17 28)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L91 0L91 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.089248cf7d1376606e06258d4d0d4d3a.svg";
export { ForwardRef as ReactComponent };